module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    ref: "usuario",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.atualizarSenha($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('senha-atual')
    }
  }, [_c('label', {
    attrs: {
      "for": "usuario"
    }
  }, [_vm._v("Senha Atual:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.old_password),
      expression: "dados.old_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha-atual",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "old_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha-atual')),
      expression: "errors.has('senha-atual')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('senha-atual')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('senha')
    }
  }, [_c('label', {
    attrs: {
      "for": "senha"
    }
  }, [_vm._v("Nova Senha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha')),
      expression: "errors.has('senha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('senha')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('confirmacaoSenha')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacaoSenha"
    }
  }, [_vm._v("Redigite a Nova Senha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmacaoSenha),
      expression: "confirmacaoSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        is: _vm.dados.password
      }),
      expression: "{required:true, is:dados.password}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "confirmacaoSenha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmacaoSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmacaoSenha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacaoSenha')),
      expression: "errors.has('confirmacaoSenha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmacaoSenha')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar")]), _vm._v(" "), _vm._m(0)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Salvar")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf0cdc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/usuarios/formAlterarSenha.vue
// module id = 389
// module chunks = 1